// extracted by mini-css-extract-plugin
export default {"container":"About_container__-Itqp","engineering":"About_engineering__wU121"};